import { NgModule } from '@angular/core';
import { PageLoaderComponent } from './page-loader.component';

@NgModule({
  declarations: [PageLoaderComponent],
  exports: [PageLoaderComponent],
})
export class PageLoaderModule {}
